const Request = {
  List: "/Tables/RequestLog/List",
  Info: "/Tables/RequestLog/Info",
  Export: "/Tables/RequestLog/Export",
};

export default {
  Request,
};
